<template lang="html">
  <div class="autogrow-textarea" @click="focusInput">
    <pre ref="pre"></pre>
    <textarea v-focus="autofocus" :disabled="disabled" :placeholder="placeholder" ref="textarea" :value="value" @blur="onBlur" @focus="onFocus" @input="onInput" @keydown.enter.prevent="$emit('enter')" @keyup.delete="$emit('delete')"></textarea>
  </div>
</template>

<script>
import focus from '@/directives/focus';

export default {
  data() {
    return {
      focussed: false,
    };
  },
  directives: {
    focus,
  },
  methods: {
    focusInput() {
      this.$el.querySelector('textarea').focus();
    },
    getSelection() {
      return {
        start: this.$refs.textarea.selectionStart,
        end: this.$refs.textarea.selectionEnd,
      };
    },
    onInput(e) {
      // this.recalculateHeight(e.target.value);
      this.$emit('input', e.target.value.replace(/\n/g, ''));
    },
    onBlur() {
      this.focussed = false;
      this.$emit('blur');
    },
    onFocus() {
      this.focussed = true;
      this.$emit('focus');
    },
    recalculateHeight(value) {
      this.$refs.pre.innerText = value;
      this.$refs.pre.appendChild(document.createElement('BR'));
      this.$el.style.height = `${this.$refs.pre.offsetHeight}px`;
    },
    setSelection(start, end) {
      if (!this.focussed) this.focusInput();
      this.$refs.textarea.setSelectionRange(start, end || start + 1);
    },
  },
  mounted() {
    this.recalculateHeight(this.value);
  },
  props: {
    autofocus: Boolean,
    dark: Boolean,
    disabled: Boolean,
    placeholder: String,
    maxLength: Number,
    validator: Function,
    value: String,
  },
  watch: {
    value(newValue) {
      this.recalculateHeight(newValue);
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '../styles/colors'
.autogrow-textarea
  cursor: text
  position: relative

  pre,
  textarea
    vertical-align: top
    margin: 0
    padding: 0
    outline: 0
    border: 0
    font-family: inherit
    font-size: inherit
    font-weight: 600
    color: inherit
    background-color: $bg
    resize: none
    white-space: pre-wrap
    word-wrap: break-word
    line-height: 1.4
    overflow: hidden

  textarea
    width: 100%
    height: 100%
    resize: none

    &::placeholder
      color: alpha($text, 0.38)
      text-transform: capitalize
      opacity: 1

    &:disabled
      background-color: transparent
      opacity: 1

  pre
    position: absolute
    top: 0px
    left: @top
    right: @top
    visibility: hidden
</style>
